import styled from 'styled-components';
import {
  justifyContent,
  JustifyContentProps,
  padding,
  PaddingProps,
} from 'styled-system';

export const SkeletonWrapper = styled.div<PaddingProps & JustifyContentProps>`
  flex: 1;
  display: flex;
  ${padding};
  ${justifyContent};
`;

SkeletonWrapper.defaultProps = {
  paddingY: 4,
};
